import {createActionGroup, emptyProps, props} from "@ngrx/store";
import {CapitalAccountCreateBody, CapitalAccountDataset, CapitalAccountStagingBlock} from "../../models/capital-account-staging";

export const CapitalAccountReviewActions = createActionGroup({
    source: "Capital Account Review",
    events: {
        load: emptyProps(),
        loadForDataset: props<{ dataset: string }>(),
        loadDatasets: emptyProps(),
        loadDatasetsSuccess: props<{ datasets: CapitalAccountDataset[] }>(),
        loadDatasetsError: props<{ errorMsg: string }>(),
        loadSuccess: props<{ blocks: CapitalAccountStagingBlock[] }>(),
        loadError: props<{ errorMsg: string }>(),
        assign: props<{ stagingId: number; sellerPositionId: number }>(),
        create: props<{ stagingId: number; body: CapitalAccountCreateBody }>(),
        defer: props<{ stagingId: number }>(),
        promoteSuccess: props<{ block: CapitalAccountStagingBlock }>(),
        promoteError: props<{ errorMsg: string }>()
    }
});
